var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
export function Fade(_a) {
    var children = _a.children, className = _a.className, _b = _a.delay, delay = _b === void 0 ? 0 : _b, _c = _a.duration, duration = _c === void 0 ? 0.4 : _c;
    var variants = {
        hidden: {
            opacity: 0,
        },
        active: {
            opacity: 1,
        },
        exit: {
            opacity: 0,
        },
    };
    return (_jsx(motion.div, __assign({ className: className, variants: variants, initial: "hidden", animate: "active", exit: "exit", transition: {
            duration: duration,
            type: 'tween',
            delay: delay,
        } }, { children: children })));
}
export default Fade;
